import React from "react";
import loadable from "@loadable/component";
import NotificationIcon from "../../Icons/NotificationIcon";
import NoticeIcon from "../../Icons/NoticeIcon";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
const NoticeListComponent = loadable(
  () => import("../../components/Notice/NoticeList")
);

const NoticeList = () => {
  return (
    <>
      <div className={tw`flex gap-x-2 mb-6 uppercase font-extrabold`}>
        <NoticeIcon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>Notice</span>
      </div>
      <NoticeListComponent />
    </>
  );
};

export default NoticeList;
